import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";

const CONTRACT_NOTIFICATION_SUBCATEGORIES: ReadonlySet<TimelineItemSubcategoryEnum> =
	new Set([
		TimelineItemSubcategoryEnum.ContractEnd,
		TimelineItemSubcategoryEnum.ContractAnniversary,
		TimelineItemSubcategoryEnum.ContractFixationEnd,
	]);

export const isContractNotificationItem = (
	item: Pick<TimelineItemResponseDTO, "category" | "subcategory">,
): boolean =>
	item.category === TimelineItemCategoryEnum.Notification &&
	!!item.subcategory &&
	CONTRACT_NOTIFICATION_SUBCATEGORIES.has(item.subcategory);
